import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import proTitle from 'assets/pro-title.svg';
import { Card } from 'atoms/icons/Card';
import { Dollar } from 'atoms/icons/Dollar';
import { Shards } from 'atoms/icons/Shards';
import { StarBall } from 'atoms/icons/StarBall';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { DisplayS } from 'atoms/typography';
import { AnimatedBackgroundBox } from 'atoms/ui/AnimatedBackgroundBox';
import { Chip } from 'atoms/ui/Chip';
import { FOOTBALL_MARKET_GO_PRO } from 'constants/__generated__/routes';
import { glossary } from 'lib/glossary';
import { absCenter } from 'lib/style';

const Root = styled(Vertical)`
  position: relative;
  isolation: isolate;
  padding: var(--double-unit);
  width: 100%;
  height: 100%;
`;
const VisibleOnHover = styled(Horizontal).attrs({ center: true })`
  ${absCenter}
  opacity: 0;
  :hover > ${Root} & {
    opacity: 1;
  }
  transition: opacity 100ms ease-in;
`;
const HiddenOnHover = styled(Horizontal).attrs({ center: true })`
  ${absCenter}
  opacity: 1;
  :hover > ${Root} & {
    opacity: 0;
  }
  transition: opacity 100ms ease-out;
`;
const RelativeWrapper = styled.div`
  position: relative;
`;
const SmallStarBall = styled(StarBall)`
  position: absolute;
  top: calc(-1 * var(--unit));
  right: calc(-1 * var(--intermediate-unit));
  width: var(--intermediate-unit);
`;
const ImgWithShadow = styled.img`
  filter: drop-shadow(0 0 10px #000);
  opacity: 0.8;
`;

export const GoProLink = () => {
  return (
    <AnimatedBackgroundBox
      to={FOOTBALL_MARKET_GO_PRO}
      primaryColor="#1CA0FF"
      backgroundVideoUrl="https://frontend-assets.sorare.com/football/so5_league/seasonal-contenders/tile_video_background.mp4"
    >
      <Root>
        <Horizontal gap={0.5}>
          <Chip>
            <Dollar size={1.5} />
          </Chip>
          <Chip>
            <Card size={1.5} gradient="blue" />
          </Chip>
          <Chip>
            <Shards size={1.5} color="var(--c-green-400)" />
          </Chip>
        </Horizontal>

        <VisibleOnHover>
          <ImgWithShadow src={proTitle} width="100%" alt="" />
        </VisibleOnHover>
        <HiddenOnHover>
          <RelativeWrapper>
            <DisplayS>
              <FormattedMessage {...glossary.goPro} />
            </DisplayS>
            <SmallStarBall />
          </RelativeWrapper>
        </HiddenOnHover>
      </Root>
    </AnimatedBackgroundBox>
  );
};
